import { render, staticRenderFns } from "./NlpMain.vue?vue&type=template&id=3bd2aa5f&scoped=true"
import script from "./NlpMain.vue?vue&type=script&lang=js"
export * from "./NlpMain.vue?vue&type=script&lang=js"
import style0 from "./NlpMain.vue?vue&type=style&index=0&id=3bd2aa5f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bd2aa5f",
  null
  
)

export default component.exports